import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ForgetPasswordAction, SetAuthLoading } from '../store/auth.actions';
import { AuthService } from '../services/auth.service';
import { BASE_URL } from 'src/environments/environment';
import { emailValidator } from 'src/app/shared/validators/fields-validators';
import { FormFieldComponent } from 'src/app/shared/ui/form-field/form-field.component';
import { ButtonComponent } from 'src/app/shared/ui/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
  imports: [ReactiveFormsModule, FormFieldComponent, ButtonComponent, RouterLink, TranslatePipe],
})
export class ForgetPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  private store = inject<Store<AppState>>(Store);
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);
  private readonly cdr = inject(ChangeDetectorRef);

  resetPasswordForm!: FormGroup;
  isDropdownOpen = false;
  currentLanguage = '';
  currentYear: number = new Date().getFullYear();
  BASE_URL = BASE_URL;
  showDBOptions = false;
  databases: string[] = [];

  ngOnInit(): void {
    localStorage.removeItem('currentUser');
    this.resetPasswordForm = this.fb.group({
      database: [''],
      email: ['', [Validators.required, emailValidator()]],
    });

    const savedLang = localStorage.getItem('lang') || 'en';
    this.translateService.use(savedLang);
    this.currentLanguage = savedLang;

    this.showDBOptions =
      ['127.0.0.1', 'localhost', 'qa-', 'preprod'].filter((value) =>
        window.location.host.includes(value)
      ).length > 0;
    this.getDBs();
  }

  switchLanguage(lang: string) {
    if (lang !== this.translateService.getCurrentLang()) {
      this.translateService.use(lang);
    }
    localStorage.setItem('lang', lang);
    this.currentLanguage = lang;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  requestPasswordReset(): boolean {
    if (!this.resetPasswordForm.valid) {
      this.resetPasswordForm.markAllAsTouched();
      return false;
    }
    this.store.dispatch(SetAuthLoading({ isLoading: true }));
    this.store.dispatch(ForgetPasswordAction({ payload: this.resetPasswordForm.value }));
    return true;
  }

  getDBs(): void {
    this.authService.getDBs().subscribe((res) => {
      this.databases = res.data;
      this.resetPasswordForm.patchValue({ database: this.databases[0] });
      this.cdr.markForCheck();
    });
  }
}
